import Vue from "vue";

export async function checkIsActive(slug) {
  const response = await Vue.prototype.$http.get(`/features/${slug}`);

  return response.data;
}

export async function index() {
  const response = await Vue.prototype.$http.get(`/feature-flags`);

  return response.data;
}

export async function show(id) {
  const response = await Vue.prototype.$http.get(`/feature-flags/${id}`);

  return response.data;
}

export async function updateActive(id, payload) {
  const response = await Vue.prototype.$http.post(
    `/feature-flags/${id}/switch`,
    payload
  );

  return response.data;
}

export async function bulkUpdateActive(payload) {
  const response = await Vue.prototype.$http.get(
    `/feature-flags/bulk-switch`,
    payload
  );

  return response.data;
}
